import { callEndpoint, callEndpointWithPayload } from '../baseApi'

export const GetEvent = async (uuid, idToken) => {
  return await callEndpoint(`${process.env.REACT_APP_API}/events/${uuid}`, 'GET', idToken)
}

export const UpdateEvent = async (uuid, idToken, payload) => {
  return await callEndpointWithPayload(`${process.env.REACT_APP_API}/events/${uuid}`, 'PATCH', idToken, payload)
}

export const DeleteEvent = async (uuid, idToken) => {
  return await callEndpoint(`${process.env.REACT_APP_API}/events/${uuid}`, 'DELETE', idToken)
}
